/**
 * "There was an old, crazy dude who used to live a long time ago. His name was Lord Buckley.
 *  And he said, a long time ago, he said, `People - they're kinda like flowers, and it's been
 *  a privilege walking in your garden.` My love goes with you." - Robin Williams
 */
/**
 *  Goodbye Joachim
 */
